import React from 'react';
import sortBy from 'lodash/sortBy';
import Lozenge from '@atlaskit/lozenge';
import { Flex, Box, Text, xcss } from '@atlaskit/primitives';
import { EntitlementIcon } from '@css-xp/base';
import { token } from '@atlaskit/tokens';
import styled from '@emotion/styled';

export const EntitlementIconStyle = styled.div`
  display: flex;
  align-items: center;
  img {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
  }
`;

export const TitleStyle = styled.div`
  padding-bottom: ${token('space.050')};
`;

interface ProductDataType {
  productId?: string;
  logoId: string;
  productName: string;
  cloudSiteHostname?: string;
  entitlementNumber?: string;
}

interface ProductDataProps {
  productData: ProductDataType;
  version?: number;
}

const ProductData = ({ productData, version }: ProductDataProps) => {
  const isNewProduct = !productData.cloudSiteHostname && !productData.entitlementNumber;
  return (
    <Box paddingBlockStart="space.150">
      <Flex>
        <Box xcss={xcss({ width: version === 2 ? '10%' : '8%' })} padding="space.050">
          <Flex alignItems={isNewProduct ? 'center' : 'start'}>
            <EntitlementIconStyle>
              <EntitlementIcon productId={productData.productId ?? ''} logoId={productData.logoId} isCloud />
            </EntitlementIconStyle>
          </Flex>
        </Box>
        <Flex alignItems={isNewProduct ? 'center' : 'start'}>
          <Box paddingInlineStart="space.100">
            <Flex direction="column">
              <Flex alignItems="center">
                <Text>{productData.productName}</Text>
                {isNewProduct && (
                  <Box paddingInlineStart="space.075">
                    <Flex>
                      <Lozenge appearance="new" isBold>
                        NEW
                      </Lozenge>
                    </Flex>
                  </Box>
                )}
              </Flex>
              {productData.cloudSiteHostname ? (
                <Text color="color.text.subtlest" size="small">
                  {productData.cloudSiteHostname}
                </Text>
              ) : null}
              {productData.entitlementNumber ? (
                <Text color="color.text.subtlest" size="small">
                  {productData.entitlementNumber}
                </Text>
              ) : null}
            </Flex>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

interface IncludedProductsSidebarProps {
  version?: number;
  productName: string;
  entitlementNumber?: string;
  includedProductsList: ProductDataType[];
}

export const IncludedProductsSidebar = ({
  version,
  productName,
  entitlementNumber,
  includedProductsList,
}: IncludedProductsSidebarProps) => {
  return (
    <Box paddingBlockStart={version === 2 ? 'space.100' : 'space.0'}>
      <Text weight="bold" size="large">
        Linked subscriptions
      </Text>
      <>
        <Box paddingBlockStart="space.400">
          <TitleStyle>
            <Text color="color.text.subtlest" size="medium">
              Products included under the {productName} {entitlementNumber ? `(${entitlementNumber})` : ''}
            </Text>
          </TitleStyle>
        </Box>
        {sortBy(includedProductsList, (productData) => productData?.productName).map((productData, idx) => {
          return <ProductData productData={productData} version={version} key={idx} />;
        })}
      </>
    </Box>
  );
};
